import { Logo } from "../Assets";
import { Link } from "react-router-dom";

import { HiOutlineMenuAlt2 } from "react-icons/hi";
import MobileNav from "./mobile-nav";
import Navigations from "./Navigations";
import { motion } from "framer-motion";
import { useState } from "react";
const Header = () => {
  const [isOpenMobileNav, setIsOpenMobileNav] = useState(false);

  return (
    <header className="fixed z-50 w-screen bg-cardOverlay backdrop-blur-md md:p-3 md:px-4 lg:p-6 lg:px-16">
      {/* Tablet and Desktop */}
      <div className="justify-between hidden w-full md:flex itesm-center">
        <Link to={"/"}>
          <motion.div
            whileHover={{ scale: 1.1 }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <img src={Logo} alt="Logo" className="object-cover w-20" />
          </motion.div>
        </Link>

        {/* navigation */}
        <Navigations />
      </div>

      {/* Mobile */}
      <motion.div
        className="flex items-center justify-between w-full p-0 md:hidden"
        initial={{ opacity: 0, x: 200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 200 }}
      >
        {isOpenMobileNav ? (
          <MobileNav isOpen={isOpenMobileNav} setIsOpen={setIsOpenMobileNav} />
        ) : (
          <div className="flex items-center justify-between w-full p-5">
            <motion.div
              whileTap={{ scale: 0.9 }}
              className="flex items-center justify-center "
              onClick={() => setIsOpenMobileNav(!isOpenMobileNav)}
            >
              <HiOutlineMenuAlt2 className="text-4xl text-headingColor" />
            </motion.div>
            <Link to={"/"}>
              <motion.div
                whileHover={{ scale: 1.1 }}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={Logo} alt="Logo" className="object-cover w-16" />
              </motion.div>
            </Link>
          </div>
        )}
      </motion.div>
    </header>
  );
};

export default Header;
